import type React from "react";
import { useHomeFilter } from "../../../hooks/useHomeFilter.ts";
import type { OverviewForm } from "../../../hooks/useOverview.ts";
import CzechMap from "./CzechMap.tsx";

interface MapFilterProps {
	overviewForm: OverviewForm;
	onMapClick: () => void; // Add prop type for the callback
}

export const MapFilter: React.FC<MapFilterProps> = ({ overviewForm, onMapClick }) => {

	return (
		<overviewForm.Field name="RegionId">
			{(fieldApi) => {
				const currentValue = fieldApi.state.value;// homeFilter.parsedFilter.RegionId;

				const handleValueChange = (value: number) => {
					const valueToUpdateWith = value === currentValue ? undefined : value;

					fieldApi.setValue(Number(valueToUpdateWith));
					// Call the callback function after setting the value
					if (valueToUpdateWith !== undefined) {
						onMapClick();
					}
				};

				return <CzechMap selected={currentValue} handleSelected={handleValueChange} />;
			}}
		</overviewForm.Field>
	);
};
